import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../enums/app-settings.enum';
import { UtilitiesService } from '../utilities/utilities.service';
import { ProductService } from '../services/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageSwitchService } from '../services/language-switch.service';
import { ApplicationInitializationService } from '../services/application-initialization.service';

@Component({
  selector: 'app-parental-control-addons',
  templateUrl: './parental-control-addons.component.html',
  styleUrls: ['./parental-control-addons.component.scss']
})
export class ParentalControlAddonsComponent implements OnInit {

  subCategory: any;
  skus: any[]=[];
  addon: any;
  activeAddon: any;
  selectedAddon;
  ENV: string = '';
  URLS: any;

  constructor(
    private UTS: UtilitiesService,
    private PS: ProductService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private LSS: LanguageSwitchService,
    private appInitService: ApplicationInitializationService
  ) { 

  }

  ngOnInit(): void {
    localStorage.removeItem('CAT');
    localStorage.removeItem('subCategoryId');
    this.getNAVURLs();
    this.getAddonsByCategories();
  }

  getAddonsByCategories() {
    this.aRoute.queryParams.subscribe((q) => {
      this.setQueryParams(q);
      if (q && q.subCategory) {
        this.subCategory = q.subCategory;
        localStorage.setItem('CAT',this.subCategory);
        this.selectedSubCategory();
      }
      else{
        localStorage.setItem('CAT',this.appInitService.environmentConfig?.PARENTAL_CONTROL_ADDONS);
        this.redirectRoute(this.appInitService.environmentConfig?.PARENTAL_CONTROL_ADDONS);
      }
    });
  }

  private async selectedSubCategory() {
    this.getSelectedSubCategory(this.subCategory, '').then((resp) => {
      if (this.subCategory == this.appInitService.environmentConfig?.PARENTAL_CONTROL_ADDONS) this.addon = 'Parental Control';
      this.selectedAddon=resp;
      this.skus=[];
          if (resp && resp.products && resp.products.length > 0) {
            for (let i = 0; i < resp.products.length; i++) {
              if (
                resp.products &&
                resp.products[i] &&
                resp.products[i].skus &&
                resp.products[i].skus.length > 0
              ) {
                for (let j = 0; j < resp.products[i].skus.length; j++) {
                  resp.products[i].skus[j].productId=resp.products[i].productId;
                  this.skus.push(resp.products[i].skus[j]);
                }
              }
            }
          }
    });
  }

  private async getSelectedSubCategory(ID: string, NS: string) {
    try {
      const response = await this.PS.getProductsByCategory(
        this.UTS.getLocaleLanguage(),
        AppSettings.IS_APPLY_DEFAULT_FILTERS,
        ID,
        NS,
        AppSettings.NO
      ).toPromise();
      return response;
    } catch (e) {
      this.UTS.error(e.message);
      return JSON.parse(AppSettings.NO_RECORD_FOUND);
    }
  }

  getNAVURLs() {
    if (this.UTS.getLocaleLanguage()=='ar') {
      this.URLS = {
        APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL
      };
    } else {
      this.URLS = {
        APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL
      };
    }
  }

  redirectRoute(subCategory: string) {
    if (subCategory) {
      this.router.navigateByUrl(
        '/parentalControlAddons?subCategory=' +
        subCategory +
        '&lang=' +
        this.UTS.getLocaleLanguage()
      );
    }
  }

  setQueryParams(q) {
    if (q && q.env) {
      this.UTS.setENV(q.env);
      this.ENV = q.env;
    } else {
      this.ENV = this.UTS.getENV();
    }

    if (
      (q && q.lang && q.lang.toLowerCase() == 'ar') ||
      (q && q.locale && q.locale.toLowerCase() == 'ar')
    ) {
      this.LSS.setLanguage(
        q.locale
          ? q.locale.toLowerCase()
          : q.lang
            ? q.lang.toLowerCase()
            : 'ar'
      );
      this.translate.setDefaultLang('ar');
    } else if (
      (q && q.lang && q.lang.toLowerCase() == 'en') ||
      (q && q.locale && q.locale.toLowerCase() == 'en')
    ) {
      this.LSS.setLanguage(
        q.locale
          ? q.locale.toLowerCase()
          : q.lang
            ? q.lang.toLowerCase()
            : 'en'
      );
      this.translate.setDefaultLang('en');
    } else {
      this.LSS.setLanguage(
        this.UTS.getLocaleLanguage().toLocaleLowerCase()
      );
      this.translate.setDefaultLang('en');
    }
  }

}
